import React, { useState } from "react";

function Newsletter({
  title = "Keep Informed",
  subtitle = "Get the latest Rho Impact and industry news.",
  formPlaceholder = "Your email...",
  formButton = "Subscribe",
  formNote = "No spam. You can unsubscribe at any time.",
}) {
  const [email, setEmail] = useState("");
  const [newsletterMessage, setNewsletterMessage] = useState("");
  const [newsletterMessageColor, setNewsletterMessageColor] =
    useState("text-green-600");
  const onSubmit = (event) => {
    event.preventDefault();

    // Basic validation that it's a valid email
    const emailRegex = /\S+@\S+\.\S+/;
    if (!emailRegex.test(email)) {
      setNewsletterMessage("Please enter a valid email address.");
      setNewsletterMessageColor("text-red-600");
      return;
    }
    const siteBaseUrl =
      process.env.GATSBY_SITE_BASE_URL || "https://rhoimpact.com";
    const functionUrl = `${siteBaseUrl}/.netlify/functions/submitToCIO`;

    const data = {
      email: email,
      form_id: "rho-impact-newsletter-v2",
      form_location: "newsletter",
    };
    fetch(functionUrl, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          setNewsletterMessage(
            `Thank you for subscribing! You will receive email to: ${email}`
          );
          setNewsletterMessageColor("text-green-600");
          setEmail(""); // Clear the email input after successful submission
        } else {
          setNewsletterMessage(
            "There was an issue subscribing you. Please try again later."
          );
          setNewsletterMessageColor("text-red-600");
        }
      })
      .catch((error) => {
        console.error("Failed to send newsletter request:", error);
        setNewsletterMessage("There was an error submitting your request.");
        setNewsletterMessageColor("text-red-600");
      });
  };
  return (
    <section>
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        {/* TODO: Remove the inline style */}
        <div className="pb-12 md:pb-20" style={{ paddingTop: "5rem" }}>
          {/* CTA box */}
          <div
            className="relative bg-rhoBlueDark-700 rounded py-10 px-8 md:py-16 md:px-12 shadow-2xl overflow-hidden"
            data-aos="zoom-y-out"
          >
            {/* Background illustration */}
            <div
              className="absolute right-0 bottom-0 pointer-events-none hidden lg:block"
              aria-hidden="true"
            >
              <svg
                width="428"
                height="328"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 350 300"
              >
                <path
                  fill="#177AFF"
                  d="M738.09,657.75c-.63.44-1.27.88-1.92,1.3a186.16,186.16,0,0,1,40.24,115.83H698.82c0-138.55-217.31-201.49-296.82,0A186.64,186.64,0,0,1,456.83,642.5H457a186.44,186.44,0,0,1,116-54.13h21l102.34-.47L713,509H539.79l-8.35,38.3s33.93-.39,66.31,2.27C527.16,564,485.38,580.13,438.52,628L480.3,427c50.28,0,87.39.12,127.41.21H733a67.48,67.48,0,0,1,13.86,1.52,62.87,62.87,0,0,1,36.56,22.39h.15a63.63,63.63,0,0,1,13.87,40.05,70.39,70.39,0,0,1-1.58,14.21L774.71,607A78.33,78.33,0,0,1,748,650.77a81.22,81.22,0,0,1-9.86,7Z"
                  transform="translate(-380 -415)"
                />
              </svg>
            </div>

            <div className="relative flex flex-col lg:flex-row justify-between items-center">
              {/* CTA content */}
              <div className="text-center lg:text-left lg:max-w-xl">
                <h3 className="h3 text-white mb-2">{title}</h3>
                <p className="text-gray-300 text-lg mb-6">{subtitle}</p>

                {/* CTA form */}
                <form onSubmit={onSubmit} method="POST" noValidate>
                  <div className="flex flex-col sm:flex-row justify-center max-w-xs mx-auto sm:max-w-md lg:mx-0">
                    <input
                      type="email"
                      className="w-full appearance-none bg-gray-800 border border-gray-700 focus:border-gray-600 rounded-sm px-4 py-3 mb-2 sm:mb-0 sm:mr-2 text-white placeholder-gray-500"
                      placeholder={formPlaceholder}
                      aria-label={formPlaceholder}
                      name="EMAIL"
                      id="MERGE0"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                      autoCapitalize="off"
                      autoCorrect="off"
                      autoComplete="off"
                      required
                    />
                    <button
                      value="Subscribe"
                      name="subscribe"
                      className="btn text-white bg-rhoBlueLight-700 hover:bg-rhoBlueLight-800 shadow"
                      type="submit"
                      aria-label="Subscribe"
                    >
                      {formButton}
                    </button>
                  </div>
                  <p className="text-sm text-gray-400 mt-3">{formNote}</p>
                  {newsletterMessage && (
                    <p className={`mt-2 text-sm ${newsletterMessageColor}`}>
                      {newsletterMessage}
                    </p>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Newsletter;
